import {
	authInterceptorFactory,
	axios,
	interceptAndNormalizeResponse,
	piggyBack,
	requestHeaderNormalizerInterceptor
} from "@teaming/io-helpers";

const IO_TIMELINE_NAMESPACE = "timeline";

export default function ioTimelineFactory( { config: { baseUri }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );
	axios.interceptors.response.use( ...interceptAndNormalizeResponse() );

	return {
		namespace: IO_TIMELINE_NAMESPACE,
		fetchTimelineEvents: piggyBack( async ( teamId ) => {
			const result = await axios({
				method: 'get',
				url: `/timeline/${teamId}`
			});
			console.log('fetchTimelineEvents', result);
			return result.data?.events || [];
		}),
		createTimelineEvent: piggyBack( async ( event ) => {
			const result = await axios({
				method: 'post',
				url: '/timeline',
				data: event
			});
			console.log('createTimelineEvent', result);
			return result.data;
		}),
	};
}
